import { Radio as RadioMantine } from '@mantine/core'
import styled from 'styled-components'

export const Radio = styled(RadioMantine)`
  .mantine-Radio-radio {
    border: 2px solid ${({ theme }) => theme.cor39} !important;
    background-color: transparent !important;

    :disabled {
      background-color: ${({ theme }) => theme.cor72} !important;
      border-color: ${({ theme }) => theme.cor73} !important;
    }

    :checked {
      background-color: transparent !important;
      border-color: ${({ theme }) => theme.cor11} !important;
      border-width: 3px !important;
    }
  }

  .mantine-Radio-icon {
    color: ${({ theme }) => theme.cor11} !important;

    width: 0.475rem;
    height: 0.475rem;
    top: calc(50% - 0.475rem / 2);
    left: calc(50% - 0.475rem / 2);
  }

  .mantine-Radio-label {
    color: ${({ theme }) => theme.cor9} !important;
    font-size: 16px !important;
    background-color: transparent !important;
    font-weight: 500;
  }
`
